let ScenarioTypes = {
        "FIELD": "field",
        "STARTUP": "startup"
}

module.exports = {ScenarioTypes}